<template>
  <div>
    <div class="card card-edit-profile" v-if="steps.profile">
      <div class="card-content">
        <form @submit.prevent="validForm()">
          <div class="row">
            <div class="col-md-12">
              <div class="alter-avatar" :class="{ 'border-green' : !!tempAvatar, 'border-white': !tempAvatar }">
                <img :src="(!!tempAvatar ? tempAvatar : currentUser.avatar_url)" :alt="currentUser.name">
                <div class="alter-avatar-hover" @click="openFile()">
                  <a href="#"> <span class="ti-camera"></span> <br> Atualizar</a>
                </div>
                <span class="hide"><input type="file" ref="avatar" @change="onFileChange" accept="image/*" capture="user"></span>
              </div>
              <div class="text-center">
                <h4 class="title"> {{ currentUser.name }}
                  <br>
                  <a href="#">
                    <small>{{ currentUser.position.name }}</small>
                  </a>
                </h4>
              </div>
            </div>
          </div>
          <div style="height: 20px;"></div>
          <div class="row">
            <div class="col-md-6">
              <fg-input type="email"
                        label="E-mail"
                        placeholder="e-mail"
                        v-model="user.email">
              </fg-input>
            </div>
            <div class="col-md-6">
              <fg-input type="text"
                        label="Telefone"
                        placeholder="telefone"
                        inputmode="numeric"
                        v-model="user.phone" v-mask="'(##) # ####-####'">
              </fg-input>
            </div>
          </div>

          <div class="text-center">
            <button type="submit" class="btn btn-success btn-fill btn-wd">
              <loading-spin :check="loading" class="loading-spin-login"></loading-spin> Salvar
            </button>
          </div>
          <div class="clearfix"></div>
        </form>
      </div>
    </div>
    <div class="card" v-if="steps.cropimage">
      <div class="card-header">
        <h4 class="card-title">Recortar Imagem</h4>
        <p class="category">Para recortar esta imagem, arraste a região abaixo e clique em "Definir como foto do perfil"</p>        
      </div>
      <div class="card-content">        
        <ImageCropper @setImage="setImage" ref="imageCropper"/>
      </div>
      <div class="card-footer text-center">
        <button type="button" class="btn btn-primary btn-fill" style="margin-top: 20px;" @click="cropImage()" title="Cortar">
          <i class="fa fa-check"></i> Definir como foto do perfil
        </button>
        <button type="button" class="btn btn-danger btn-fill" style="margin-top: 20px;" @click="handleStep('profile')">Cancelar</button>
      </div>
    </div>
  </div>
</template>
<script>
  import {mask} from 'vue-the-mask'
  import swal from 'sweetalert2'
  import ImageCropper from './ImageCropper'
  import { readOrientation } from '../../../../../helpers/general'

  export default {
    directives: {mask},
    mounted () {
      this.user.email = this.currentUser.email
      this.user.phone = this.currentUser.phone
    },
    data () {
      return {
        user: {
          email: '',
          phone: '',
          avatar: null
        },
        tempAvatar: null,
        steps: {
          profile: true,
          cropimage: false
        },
        loading: false
      }
    },
    components: {
      ImageCropper
    },
    methods: {
      validForm () {
        if (!!this.user.email && !!this.user.phone) {
          this.saveData()
        } else {
          this.setAlert('warning', 'Atenção!', 'Preencha todos os campos.')
        }
      },
      async saveData () {
        this.loading = true
        let user = await this.saveUser()

        if (this.user.avatar) {
          let avatar = await this.saveAvatar()
          user = Object.assign(user, avatar)
        }

        this.loading = false

        if (user.hasOwnProperty('email') || user.hasOwnProperty('phone') || user.hasOwnProperty('avatar_url')) {
          this.updateDataStorage(user)
        }
      },
      async saveUser () {
        let url = `/collaborator`
        let user = this.user
        let dataUser = {}

        if (this.currentUser.email === user.email && this.currentUser.phone === user.phone) {
          return dataUser
        }

        await axios.put(url, user).then((response) => {
          dataUser = { 'email': user.email, 'phone': user.phone }
          this.setAlert('success', 'Alterado!', response.data.message)
        }).catch((error) => {
          dataUser = { 'email': null, 'phone': null }
          console.log(error)
        })

        return dataUser
      },
      async saveAvatar () {
        let url = `/collaborator/upload-avatar`

        let data = new FormData()
        // Data
        data.append('avatar', this.user.avatar)

        let config = {
          'Content-Type': 'multipart/form-data'
        }

        let dataAvatar = {}

        await axios.post(url, data, config)
        .then((response) => {
          dataAvatar = { 'avatar_url': response.data.avatar_url }
          this.setAlert('success', 'Alterado!', 'Imagem de perfil alterado com sucesso.')
        }).catch((error) => {
          dataAvatar = { 'avatar_url': null }
          this.setAlert('warning', 'Atenção!', 'Não foi possível enviar sua imagem.')
          console.log(error)
        })

        return dataAvatar
      },
      updateDataStorage (user) {
        let userStorage = this.currentUser

        if (user.email) {
          userStorage.email = user.email
        }

        if (user.phone) {
          userStorage.phone = user.phone
        }

        if (user.avatar_url) {
          userStorage.avatar_url = user.avatar_url
          this.cleanInputFile()
          this.tempAvatar = null
        }

        this.$store.commit('alterUserData', userStorage)
      },
      openFile () {
        $(this.$refs.avatar).trigger('click')
      },
      // toBase64 (file) { // URL.createObjectURL(file)
      //   return (new Promise((resolve, reject) => {
      //     const reader = new FileReader()
      //     reader.readAsDataURL(file)
      //     reader.onload = () => resolve(reader.result)
      //     reader.onerror = error => reject(error)
      //   }))
      // },
      cleanInputFile () {
        this.user.avatar = null
        $(this.$refs.avatar).val(null)
      },
      async onFileChange () {
        let files = this.$refs.avatar.files

        if (files.length > 0) {
          let file = files[0]

          if (this.verifExtension(file)) {
            this.resizeImage(file)
          } else {
            this.cleanInputFile()
          }
        } else {
          this.tempAvatar = null
        }
      },
      verifExtension (file) {
        let check = false
        let fileTypes = ['image/png', 'image/jpeg']

        if (fileTypes.indexOf(fileTypes.find((fileType) => fileType === file.type)) > -1) {
          check = true
        } else {
          this.setAlert('warning', 'Atenção!', 'Arquivo selecionado não é permitido.')
        }

        return check
      },
      // verfiSizeFile (file) {
      //   let fileSize = (file.size / 1024) / 1024 // in MB
      //   let check = false

      //   if (fileSize <= 1) { // 1 MB
      //     check = true
      //   } else {
      //     this.setAlert('warning', 'Atenção!', `O tamanho da imagem excede o limite permitido - 1 MB.`)
      //   }

      //   return check
      // },
      resizeImage (file) {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = readerEvent => {
          const img = new Image()
          img.src = readerEvent.target.result
          img.onload = async () => {
            const canvas = await this.convertImageToCanvas(img, file)
            this.handleStep('cropimage') // Abrir Crop Image
            const imageUrl = await canvas.toDataURL('image/jpeg', 1) // 1 - Full Quality
            this.$refs.imageCropper.render(imageUrl) // Cortar Imagem
          }
        }
      },
      async convertImageToCanvas (image, file) {
        const { width, height } = this.proportionalResize(image.width, image.height)
        const canvas = document.createElement('canvas')
        const context = canvas.getContext('2d')
        let orientation
        await readOrientation(file).then(res => { orientation = res })

        if ([6].includes(orientation)) {
          canvas.width = height
          canvas.height = width
        } else {
          canvas.width = width
          canvas.height = height
        }

        context.imageSmoothingEnabled = true

        switch (orientation) {
          case 2:
            context.transform(-1, 0, 0, 1, width, 0)
            break
          case 3:
            context.transform(-1, 0, 0, -1, width, height)
            break
          case 4:
            context.transform(1, 0, 0, -1, 0, height)
            break
          case 5:
            context.transform(0, 1, 1, 0, 0, 0)
            break
          case 6:
            context.transform(0, 1, -1, 0, height, 0)
            break
          case 7:
            context.transform(0, -1, -1, 0, height, width)
            break
          case 8:
            context.transform(0, -1, 1, 0, 0, width)
            break
          default:
            context.transform(1, 0, 0, 1, 0, 0)
            break
        }

        context.drawImage(image, 0, 0, width, height)
        context.beginPath()
        context.fill()

        return canvas
      },
      cropImage () {
        this.$refs.imageCropper.cropImage()
      },
      setImage (data) {
        const { file, url } = data
        this.user.avatar = file
        this.tempAvatar = url
        this.handleStep('profile')
      },
      proportionalResize (width, height) {
        return {
          width: Math.round((480 * width) / height),
          height: 480
        }
      },
      setAlert (type, title, text) {
        swal({
          title,
          text,
          type,
          confirmButtonClass: 'btn btn-info btn-fill',
          buttonsStyling: false
        })
      },
      handleStep (step) {
        switch (step) {
          case 'profile':
            this.steps.profile = true
            this.steps.cropimage = false
            break
          case 'cropimage':
            this.steps.cropimage = true
            this.steps.profile = false
            break
        }
      }
    },
    computed: {
      currentUser () {
        return this.$store.getters.currentUser
      }
    }
  }

</script>
<style>
  .card-edit-profile .alter-avatar.border-white {
    border: 5px solid #e6ecf2;
  }

  .card-edit-profile .alter-avatar.border-green {
    border: 5px solid #46dbaf;
  }

  .card-edit-profile .alter-avatar {
    width: 170px;
    height: 170px;
    border-radius: 50%;
    position: relative;
    margin-bottom: 15px;
    cursor: pointer;
    margin: 0 auto;
  }

  .card-edit-profile .alter-avatar img {
    width: 160px;
    height: 160px;
    border-radius: 50%;
  }

  .card-edit-profile .alter-avatar-hover {
    background: #000;
    background: rgba(0, 0, 0, .6);
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 50%;
    transition: top .13s ease-out;
    border-bottom-left-radius: 80px;
    border-bottom-right-radius: 80px;
    z-index: 1;
    visibility: hidden;
  }

  .card-edit-profile .alter-avatar-hover a {
    color: #fff;
    font-size: 14px;
    margin-top: 15px;
    font-weight: 500;
    line-height: 1.4em;
    display: block;
    text-align: center;
  }

  .card-edit-profile .alter-avatar:hover .alter-avatar-hover {
    visibility: visible;
  }

  .button-right {
    position: absolute; top: 0; right: 0; margin-top: 20px; margin-right: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Pages/UserProfile/EditProfileForm.vue